// eslint-disable-next-line no-undef
// const { API_URL } = window.config;

export default {
  production: {
    apiUrl: "API_URL",
    appUrl: 'https://braiven.io',
    log_level: 'silent',
  },
  development: {
    apiUrl: "API_URL",
    appUrl: 'http://localhost:3000',
    log_level: undefined,
  },
};
